import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Heart, Shield, Leaf, TrendingUp } from 'lucide-react';
import '../../../assets/styles/customer/layout/OurValuesSection.css';

const OurValuesSection = () => {
  const values = [
    {
      id: 1,
      icon: <Heart size={36} strokeWidth={2} />,
      title: 'Customer First',
      description: 'We build every feature with our users in mind, ensuring simplicity and effectiveness.',
      color: '#f44336'
    },
    {
      id: 2,
      icon: <Shield size={36} strokeWidth={2} />,
      title: 'Trust & Transparency',
      description: 'Honest pricing, clear billing, and reliable service are the foundations of our platform.',
      color: '#3e96e7'
    },
    {
      id: 3,
      icon: <Leaf size={36} strokeWidth={2} />,
      title: 'Sustainability',
      description: 'Reducing paper waste by digitizing dairy records and promoting eco-friendly operations.',
      color: '#4caf50'
    },
    {
      id: 4,
      icon: <TrendingUp size={36} strokeWidth={2} />,
      title: 'Continuous Innovation',
      description: 'Always improving our platform based on real feedback from distributors and customers.',
      color: '#9c27b0'
    }
  ];

  return (
    <section className="our-values-section">
      
      {/* Floating Bottles */}
      <div className="values-floating-bottles">
        <div className="values-bottle bottle-1">🥛</div>
        <div className="values-bottle bottle-2">🥛</div>
        <div className="values-bottle bottle-3">🥛</div>
        <div className="values-bottle bottle-4">🥛</div>
      </div>

      {/* Wavy Backgrounds */}
      <div className="values-wave-bg">
        <svg className="values-wave wave-top" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(76, 175, 80, 0.04)" 
            d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,154.7C672,149,768,171,864,181.3C960,192,1056,192,1152,181.3C1248,171,1344,149,1392,138.7L1440,128L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg>
        <svg className="values-wave wave-bottom" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(62, 150, 231, 0.03)" 
            d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,213.3C672,224,768,224,864,213.3C960,203,1056,181,1152,186.7C1248,192,1344,224,1392,240L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>

      {/* Decorative Circles */}
      <div className="values-circles">
        <div className="values-circle circle-1"></div>
        <div className="values-circle circle-2"></div>
      </div>

      <Container>
        
        {/* Section Header */}
        <div className="values-header text-center">
          <h2 className="values-title">
            Our <span className="values-highlight">Values</span>
          </h2>
          <p className="values-subtitle">
            The principles that guide everything we do
          </p>
        </div>

        {/* Values Cards Grid */}
        <Row className="g-4 values-cards-row">
          {values.map((value, index) => (
            <Col lg={3} md={6} sm={6} xs={12} key={value.id}>
              <div 
                className="value-card"
                style={{ animationDelay: `${index * 0.12}s` }}
              >
                {/* Icon Circle */}
                <div 
                  className="value-icon-circle"
                  style={{ backgroundColor: `${value.color}15` }}
                >
                  <div 
                    className="value-icon"
                    style={{ color: value.color }}
                  >
                    {value.icon}
                  </div>
                </div>

                {/* Content */}
                <h3 className="value-card-title">{value.title}</h3>
                <p className="value-card-description">{value.description}</p>

                {/* Hover Glow */}
                <div 
                  className="value-card-glow"
                  style={{ background: `radial-gradient(circle, ${value.color}20, transparent)` }}
                ></div>
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default OurValuesSection;